import React from 'react';
import ReactDOM from 'react-dom/client';
import 'react-image-crop/dist/ReactCrop.css';
import { ConfigProvider } from 'antd';
import ptBR from 'antd/es/locale/pt_BR'
import './index.css';
import AppRouter from './router/AppRouter';
import { AuthProvider } from './router/AuthContext';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ConfigProvider locale={ptBR}>
      <AuthProvider>
        <AppRouter />
      </AuthProvider>
    </ConfigProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
